// extracted by mini-css-extract-plugin
export var alertIcon = "_sc-0";